module.exports = __webpack_public_path__ + "img/icon_flag_hk.2163ad6b.png";